<!--<nz-affix [nzOffsetBottom]="bottom">-->
<!--</nz-affix>-->
<div #fixedEl>
  <div
    class="flex flex-row items-center justify-between p-[30px] -mx-[30px] bg-white"
    style="box-shadow: 0 5px 15px rgba(161, 161, 161, 0.35)"
  >
    <span class="text-m">
      {{ "component-selected_panel_html_已选择" | translate : { number: selectedCount } }}
      <!-- {{ selectedCount }} items selected. -->
    </span>

    <ng-content select=".selected-panel-btns"></ng-content>
  </div>
</div>
